import {
  COUNTRIES,
  CONTACT_TITLES,
  EUPAS_DATA_SOURCES,
  EUPAS_CENTERS,
  ENCEPP_REGISTERED_DATA_SOURCES,
  STUDY_SCOPES,
  STUDY_TOPICS,
  CLINICAL_TRIAL_REGULATORY_SCOPES,
  DATA_COLLECTION_METHODS,
  CLINICAL_TRIAL_TYPES,
  STUDY_PHASES,
  OBSERVATIONAL_STUDY_MODEL,
  ALLOCATION,
  YES_NO_UNKNOWN,
  YES_NO_UNKNOWN_NA,
  AGE_GROUPS,
  SPECIAL_INTERESTS_OF_POPULATION,
  NONE_YES_NO_NA,
  SOURCE_OF_FUNDING,
  DATA_SOURCE_TYPES,
  CDM_NAMES,
} from "../enum/enum"
import {
  COUNTRY_MAPPING,
  STUDY_PHASE_MAPPING,
  OBSERVATIONAL_STUDY_MODEL_MAPPING,
} from "../utils/registryOptionsMapping"

const EUPAS_COUNTRIES = COUNTRIES.filter((country) => country.value !== "Korea, South")

export const eupasProperties = {
  study_identification: {
    eupas_registry_number: {
      type: "string",
    },
    darwin_eu_study: {
      type: "string",
      options: YES_NO_UNKNOWN,
    },
    study_topic: {
      type: "string",
      enum: [],
      options: STUDY_TOPICS,
    },
    emarwd_official_title_and_acronym: {
      type: "string",
    },
    is_requested_by_regulator: {
      type: "string",
      enum: [],
      options: YES_NO_UNKNOWN,
    },
    is_study_required_by_risk_management_plan: {
      type: "string",
      enum: [
        "EU RMP category 1 (imposed as condition of marketing authorisation)",
        "EU RMP category 2 (specific obligation of marketing authorisation)",
        "EU RMP category 3 (required)",
        "Non-EU RMP only",
        "Not Applicable",
      ],
    },
    other_study_ids: {
      type: "string",
    },
    other_study_identification_numbers: {
      type: "array",
      items: {
        type: "object",
        properties: {
          url: {
            type: "string",
          },
          link: {
            type: "number",
          },
        },
      },
    },
  },
  contact_information: {
    institution_conducting_study: {
      type: "string",
      enum: [],
      options: [],
    },
    institution_conducting_study_if_not_in_list: {
      type: "string",
    },
    additional_institutions: {
      type: "string",
      enum: [],
      options: [],
    },
    additional_institutions_if_not_in_list: {
      type: "string",
    },
    networks_registered_encepp: {
      type: "string",
      enum: [],
      options: [],
    },
    centers_registered_encepp: {
      type: "array",
      uniqueItems: true,
      items: {
        type: "string",
        enum: [],
        options: EUPAS_CENTERS,
      },
    },
    other_networks: {
      type: "string",
    },
    country_study_is_conducted: {
      type: "string",
      enum: [],
      options: EUPAS_COUNTRIES,
      valueMapping: COUNTRY_MAPPING,
      uniqueItems: true,
      items: {
        type: "string",
        enum: [],
        options: EUPAS_COUNTRIES,
        valueMapping: COUNTRY_MAPPING,
      },
    },
    investigator_contact_details: {
      type: "object",
      properties: {
        lead_investigator: {
          type: "object",
          properties: {
            title: {
              type: "string",
              enum: [],
              options: CONTACT_TITLES,
            },
            first_name: {
              type: "string",
            },
            last_name: {
              type: "string",
            },
            orcid: {
              type: "string",
            },
            // address_1: {
            //   type: "string",
            // },
            // address_2: {
            //   type: "string",
            // },
            // address_3: {
            //   type: "string",
            // },
            // city: {
            //   type: "string",
            // },
            // zipcode: {
            //   type: "string",
            // },
            // country: {
            //   type: "string",
            //   enum: [],
            //   options: EUPAS_COUNTRIES,
            //   valueMapping: COUNTRY_MAPPING,
            // },
            // phone_number: {
            //   type: "string",
            // },
            // phone_number_alt: {
            //   type: "string",
            // },
            // fax_number: {
            //   type: "string",
            // },
            // email: {
            //   type: "string",
            // },
            // confirm_email: {
            //   type: "string",
            // },
          },
        },
      },
    },
  },
  study_timeline: {
    signed_funding_contract_date: {
      type: "object",
      properties: {
        planned: {
          type: "string",
        },
        actual: {
          type: "string",
        },
      },
    },
    // data_collection_start_date: {
    //   type: "object",
    //   properties: {
    //     planned: {
    //       type: "string",
    //     },
    //     actual: {
    //       type: "string",
    //     },
    //   },
    // },
    data_analysis_start_date: {
      type: "object",
      properties: {
        planned: {
          type: "string",
        },
        actual: {
          type: "string",
        },
      },
    },
    interim_report_date: {
      type: "object",
      properties: {
        planned: {
          type: "string",
        },
        actual: {
          type: "string",
        },
      },
    },
    final_study_report_date: {
      type: "object",
      properties: {
        planned: {
          type: "string",
        },
        actual: {
          type: "string",
        },
      },
    },
    more_details_sources_of_funding: {
      type: "string",
    },
  },
  study_description: {
    // medical_conditions: {
    //   type: "array",
    //   items: {
    //     type: "object",
    //     properties: {
    //       condition: {
    //         type: "string",
    //       },
    //     },
    //   },
    // },

    additional_medical_conditions: {
      type: "string",
    },
  },
  study_scope: {
    shared: {
      other_scope_description: {
        type: "string",
      },
      design_of_study: {
        type: "string",
      },
      clinical_trial_regulatory_scope: {
        type: "string",
        enum: [],
        options: CLINICAL_TRIAL_REGULATORY_SCOPES,
      },
      data_collection_method: {
        type: "string",
        enum: [],
        options: DATA_COLLECTION_METHODS,
      },
      study_phase: {
        type: "string",
        enum: [],
        options: STUDY_PHASES,
        valueMapping: STUDY_PHASE_MAPPING,
      },
      allocation: {
        type: "string",
        enum: [],
        options: ALLOCATION,
      },
      summary_results: {
        type: "string",
      },
      scope_of_study: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: [],
          options: STUDY_SCOPES,
        },
      },
    },
    interventional: {
      clinical_trial_type: {
        type: "string",
        enum: [],
        options: CLINICAL_TRIAL_TYPES,
      },
    },
    observational: {
      observational_study_model: {
        type: "string",
        enum: [],
        options: OBSERVATIONAL_STUDY_MODEL,
        valueMapping: OBSERVATIONAL_STUDY_MODEL_MAPPING,
      },
      other_non_interventional_study_design: {
        type: "string",
      },
    },
  },
  study_eligibilty: {
    population_under_study: {
      type: "object",
      properties: {
        age: {
          type: "array",
          uniqueItems: true,
          items: {
            type: "string",
            enum: [
              "Preterm newborns",
              "Term newborns (0-27 days)",
              "Infants and toddlers (28 days - 23 months)",
              "Children (2 - 11 years)",
              "Adolescents (12 - 17 years)",
              "Adults (18 - 44 years)",
              "Adults (45 - 64 years)",
              "Adults (65 - 74 years)",
              "Adults (74 years and over)",
            ],
          },
        },
        other_population: {
          type: "array",
          uniqueItems: true,
          items: {
            type: "string",
            enum: ["Unselected", "Renal impaired", "Hepatic impaired", "Immunocompromised", "Pregnant women"],
          },
        },
      },
    },
    age_groups: {
      type: "array",
      uniqueItems: true,
      options: AGE_GROUPS,
      items: {
        type: "string",
        enum: [],
        options: AGE_GROUPS,
      },
    },
    special_interest_of_population: {
      type: "array",
      uniqueItems: true,
      options: SPECIAL_INTERESTS_OF_POPULATION,
      items: {
        type: "string",
        enum: [],
        options: SPECIAL_INTERESTS_OF_POPULATION,
      },
    },
    other_special_interest_of_population: {
      type: "string",
    },
    short_description_of_study_population: {
      type: "string",
    },
  },
  study_arms: {
    shared: {
      setting: {
        type: "string",
      },
      comparators: {
        type: "string",
      },
      medicine_name: {
        type: "string",
        enum: [],
        options: [],
      },
      other_medicine_name: {
        type: "string",
      },
      substance_inns: {
        type: "string",
        enum: [],
        options: [],
      },
      atc_code: {
        type: "string",
        enum: [],
        options: [],
      },
    },
    interventional: {
      eupas_interventions: {
        type: "string",
      },
    },
  },
  study_reference: {
    is_requesting_encepp_seal: {
      type: "string",
      enum: [],
      options: YES_NO_UNKNOWN,
    },
    study_publications: {
      type: "array",
      minItems: 1,
      maxItems: 5,
      items: {
        type: "object",
        properties: {
          reference: {
            type: "string",
          },
          url: {
            type: "string",
          },
        },
      },
    },
    encepp_code_of_conduct: {
      type: "string",
      enum: [],
      options: NONE_YES_NO_NA,
    },
  },
  study_outcome_measures: {
    eupas_outcomes: {
      type: "string",
    },
    statistical_analysis_plan: {
      type: "string",
    },
  },
  ema_hma_additional_information: {
    type: "object",
    properties: {
      data_sources_used_converted_to_cdm: {
        type: "string",
        enum: [],
        options: YES_NO_UNKNOWN,
      },
      cdm_mapping: {
        type: "array",
        maxItems: 3,
        items: {
          type: "object",
          properties: {
            cdm_names: {
              type: "string",
              enum: [],
              options: CDM_NAMES,
            },
            other_cdm_name: {
              type: "string",
            },
            cdm_version: {
              type: "string",
            },
          },
        },
      },
      data_quality_specifications: {
        type: "object",
        properties: {
          check_conformance: {
            type: "object",
            properties: {
              check_conformance_of_data_completed: {
                type: "string",
                enum: [],
                options: YES_NO_UNKNOWN,
              },
            },
          },
          check_completeness: {
            type: "object",
            properties: {
              check_completeness_of_data_completed: {
                type: "string",
                enum: [],
                options: YES_NO_UNKNOWN,
              },
            },
          },
          check_stability: {
            type: "object",
            properties: {
              check_stability_of_data_over_time_completed: {
                type: "string",
                enum: [],
                options: YES_NO_UNKNOWN,
              },
            },
          },
          check_logical_consistency: {
            type: "object",
            properties: {
              check_logical_consistency_of_data_completed: {
                type: "string",
                enum: [],
                options: YES_NO_UNKNOWN,
              },
            },
          },
        },
      },
      data_characterisation: {
        type: "object",
        properties: {
          data_characterisation_conducted: {
            type: "string",
            enum: [],
            options: YES_NO_UNKNOWN_NA,
          },
          procedure_of_data_extraction: {
            type: "object",
            properties: {
              url: {
                type: "string",
              },
              link_text: {
                type: "string",
              },
            },
          },
          procedure_of_results_generation: {
            type: "object",
            properties: {
              url: {
                type: "string",
              },
              link_text: {
                type: "string",
              },
            },
          },
        },
        dependencies: {
          data_characterisation_conducted: {
            oneOf: [
              {
                properties: {
                  data_characterisation_conducted: {
                    enum: ["Yes"],
                  },
                  data_characterisation_moment: {
                    type: "string",
                    enum: [
                      "After data extraction",
                      "After extract-transform-load to a common data model",
                      "After creation of study variables",
                    ],
                  },
                  data_characterisation_detail: {
                    type: "string",
                  },
                  data_characterisation_detail_link: {
                    type: "object",
                    properties: {
                      url: {
                        type: "string",
                      },
                      link_text: {
                        type: "string",
                      },
                    },
                  },
                },
              },
            ],
          },
        },
      },
      source_of_funding: {
        type: "string",
        uniqueItems: true,
        options: SOURCE_OF_FUNDING,
        items: {
          type: "string",
          enum: [],
          options: SOURCE_OF_FUNDING,
        },
      },
      registered_data_sources: {
        type: "array",
        uniqueItems: true,
        options: ENCEPP_REGISTERED_DATA_SOURCES,
        items: {
          type: "string",
          enum: [],
          options: ENCEPP_REGISTERED_DATA_SOURCES,
        },
      },
      other_registered_data_sources: {
        type: "string",
      },
      sources_of_data: {
        type: "array",
        uniqueItems: true,
        options: DATA_SOURCE_TYPES,
        items: {
          type: "string",
          enum: [],
          options: DATA_SOURCE_TYPES,
        },
      },
      other_data_source: {
        type: "string",
      },
    },
  },
}

export const eupasDependencies = {
  study_identification: {
    study_topic: {
      oneOf: [
        {
          properties: {
            study_topic: {
              enum: ["Other"],
            },
            study_topic_other: {
              type: "string",
            },
          },
        },
      ],
    },
    is_requested_by_regulator: {
      oneOf: [
        {
          properties: {
            is_requested_by_regulator: {
              enum: ["Yes"],
            },
            country_regulator_not_listed: {
              type: "string",
            },
          },
        },
        {
          properties: {
            is_requested_by_regulator: {
              enum: ["No", "Unknown"],
            },
          },
        },
      ],
    },
    is_study_required_by_risk_management_plan: {
      oneOf: [
        {
          properties: {
            is_study_required_by_risk_management_plan: {
              enum: ["EU RMP category 1 (imposed as condition of marketing authorisation)"],
            },
            regulatory_procedure_number: {
              type: "string",
            },
          },
        },
        {
          properties: {
            is_study_required_by_risk_management_plan: {
              enum: ["EU RMP category 2 (specific obligation of marketing authorisation)"],
            },
            regulatory_procedure_number: {
              type: "string",
            },
          },
        },
      ],
    },
  },
  contact_information: {},
  study_eligibilty: {},
  study_description: {},
  study_arms: {},
  study_scope: {
    // observational_study_model: {
    //   oneOf: [
    //     {
    //       properties: {
    //         observational_study_model: {
    //           enum: ["Other"],
    //         },
    //         other_non_interventional_study_design: {
    //           type: "string",
    //         },
    //       },
    //     },
    //   ],
    // },
  },
}
